import { extend } from '@/lib/utils/extend';
import Util from '@/lib/util';
export function StartUp() {
    return Promise.all([Util.initBrowserIdentity(), abpInitial()]);
}
export function StartUpWithVm(vue) {
    var promises = [];
    promises.push(vue.$store.dispatch({ type: 'session/init' }));
    return Promise.all(promises);
}
function abpInitial() {
    return abp.ajax.request({
        method: 'get',
        url: '/AbpUserConfiguration/GetAll'
    }).then(function (result) {
        extend(true, window.abp, result.data.result);
        abp.initial = true;
    });
}
